import { render, staticRenderFns } from "./btn-loading.mpx?vue&type=template&id=46eab45e&isComponent&outputPath=components%2Fbtn-loading6f8ce691%2Findex"
import script from "./btn-loading.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-loading6f8ce691%2Findex"
export * from "./btn-loading.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-loading6f8ce691%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports